import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

const Container = styled.div`
    ${({ theme }) => theme.paddings.containerOuterInner.left}
    ${({ theme }) => theme.paddings.containerOuterInner.right}

   position: relative;
`;

const Video = ({ url, image }) => {
    const theme = useTheme();

    let realURL = null;
    let imgSrc = image?.src;

    try {
        const { videoId } = url.match(
            /^https:\/\/(?:www\.)?youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/)(?<videoId>[\w_-]+)$/
        ).groups;
        realURL = `https://www.youtube-nocookie.com/embed/${videoId}`;
        // @TODO We have to cache this somewhere so that users won't request anything from YouTube until they've consented
        imgSrc =
            image?.src ??
            `https://i3.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
    } catch (error) {
        console.error(
            "Could not parse Youtube-URL make sure you are using the long Format e.g. https://www.youtube.com/watch?v={id} and no URL shortener."
        );
    }

    const styledIfreame = css`
        width: 100%;
        height: 350px;
        ${theme.breakpoints.from.small.css`
          height: 400px;
       `}
        ${theme.breakpoints.from.medium.css`
          height: 550px;
        `}
        ${theme.breakpoints.from.large.css`
          height: 700px;
        `}
    `;

    return (
        <>
            {imgSrc && (
                <iframe
                    css={styledIfreame}
                    src={realURL}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
        </>
    );
};

const VideoElement = ({ url, image, withContainer = true }) => {
    return (
        <>
            {withContainer ? (
                <Container>
                    <Video url={url} image={image} />
                </Container>
            ) : (
                <Video url={url} image={image} />
            )}
        </>
    );
};

export default VideoElement;
